import { useContext } from 'react';
import SalesEnablementContext from '../context/SalesEnablementContext';

const useSalesEnablementContext = () => useContext(SalesEnablementContext);

export default useSalesEnablementContext;
